/**
 * Mobile-only: 스크롤 후 헤더 전체 숨김, voucher banner만 유지.
 * .shopify-section-header에 is-mobile-header-hidden 토글 (CSS는 section-header.css).
 *
 * 데스크톱(≥990px)은 always-sticky 그대로 (간섭 없음).
 */
(function () {
  var DESKTOP_MIN = 990;
  var TOP_THRESHOLD = 80;
  var HIDDEN = 'is-mobile-header-hidden';
  var section, ticking = false;
  var anchorLinks = [];
  var anchorTargets = [];

  function samePageAnchor(link) {
    if (!link.hash || link.hash === '#') return false;
    return link.origin === window.location.origin && link.pathname === window.location.pathname;
  }

  function setActiveLink(activeLink) {
    anchorLinks.forEach(function (link) {
      var isActive = link === activeLink;
      link.classList.toggle('header__menu-item--active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'location');
      } else if (link.getAttribute('aria-current') === 'location') {
        link.removeAttribute('aria-current');
      }
    });
  }

  function findAnchorTarget(hash) {
    var id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (error) {
      id = hash.slice(1);
    }

    return document.getElementById(id) || Array.prototype.find.call(
      document.querySelectorAll('[data-anchor]'),
      function (el) {
        return el.dataset.anchor === id;
      }
    );
  }

  function updateActiveNav() {
    if (!anchorTargets.length) return;
    if (window.innerWidth >= DESKTOP_MIN) {
      setActiveLink(null);
      return;
    }
    if (document.documentElement.classList.contains('is-anchor-scrolling')) return;

    var headerHeight = section && !section.classList.contains(HIDDEN) ? section.getBoundingClientRect().height : 0;
    var probeY = window.pageYOffset + headerHeight + 8;
    var active = null;

    anchorTargets.forEach(function (item) {
      var top = item.target.getBoundingClientRect().top + window.pageYOffset;
      if (probeY >= top) active = item.link;
    });

    setActiveLink(active);
  }

  function initActiveNav() {
    anchorLinks = Array.prototype.slice.call(document.querySelectorAll('.header__inline-menu .header__menu-item'))
      .filter(samePageAnchor);

    anchorTargets = anchorLinks.map(function (link) {
      return {
        link: link,
        target: findAnchorTarget(link.hash)
      };
    }).filter(function (item) {
      return item.target;
    });

    anchorLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        if (window.innerWidth >= DESKTOP_MIN) return;
        setActiveLink(link);
        window.setTimeout(updateActiveNav, 1500);
      });
    });

    updateActiveNav();
  }

  function update() {
    ticking = false;
    if (!section) return;

    if (window.innerWidth >= DESKTOP_MIN) {
      updateActiveNav();
      section.classList.remove(HIDDEN);
      return;
    }

    // 앵커 스무스 스크롤 진행 중엔 헤더 상태 고정 — 도착 위치 정확도 보장
    if (document.documentElement.classList.contains('is-anchor-scrolling')) {
      return;
    }
    updateActiveNav();

    var y = window.pageYOffset;
    var maxY = document.documentElement.scrollHeight - window.innerHeight;
    if (y < 0 || y > maxY) return; // iOS 러버밴드 가드

    section.classList.toggle(HIDDEN, y >= TOP_THRESHOLD);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function init() {
    section = document.querySelector('.shopify-section-header');
    if (!section) return;
    initActiveNav();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('hashchange', updateActiveNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
